import { render, staticRenderFns } from "./DragIcon.vue?vue&type=template&id=0f733b16"
import script from "./DragIcon.vue?vue&type=script&lang=js"
export * from "./DragIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports